import React, { memo, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

function InfiniteLoaderBtn({ isPublic, children, btnProps = {}, rQueryProps = {} }) {
  const { ref, inView } = useInView();

  const { isFetchingNextPage, hasNextPage, fetchNextPage } = rQueryProps || {};

  useEffect(() => {
    if (!isPublic && inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [inView]);

  return (
    /**
     * Currently, this button will not be visible in the UI as the background, color is made transparent.
     * This will be visible in the DOM.
     */
    <button ref={ref} {...btnProps} className={`btn btn-sm invisible loadMoreBtn`}>
      {children ||
        (isFetchingNextPage
          ? 'Loading more...'
          : hasNextPage
          ? 'Load newer'
          : 'Nothing more to load')}
    </button>
  );
}

InfiniteLoaderBtn.defaultProps = {
  rQueryProps: {
    isFetchingNextPage: false,
    hasNextPage: false,
    fetchNextPage: () => {},
  },
};
export default memo(InfiniteLoaderBtn);
